export const travelExpertList = {
    items: [
        {
            rating: 5,
            firstName: 'Andrej',
            lastName: 'Kopsch',
            image: 'https://ctsassets1.check24.de/size=100c100/di=3/nfc=200/source=aHR0cHM6Ly9kb2NzLnJlaXNlbi5jaGVjazI0LmRlLzUwNzI5MzYvMzM1Zjc3ZDc2ODczOTEwOGIxODZjMTZlOTU4OGJkMDgzODZhNjI5MQ==!9529e9/picture.jpg?cts_do=DESKTOP&cts_p=PR',
            quote: 'Sie suchen die richtige Mischung aus Shopping, Strand und Sightseeing? Gerne helfe ich Ihnen mit einer Empfehlung auf den Balearen weiter.',
            phone: '089 7080 80 1001',
            jobTitle: 'Reiseberater',
            idHash: 'a89snwxeiqd80s9vth6hjqxiqxe62c50h66vlgygcehvuv',
            phoneLink: '+49897080801001',
            label: 'Reiseberater Balearen',
            special: 'CHECK24 Reiseexperte',
            education: 'als Kundenberater',
            experience: '7 Jahre Berufserfahrung',
            region: 'Mallorca',
            promo: '',
            phoneNumber: '',
            gender: '',
            serviceCode: '',
        },
        {
            rating: 5,
            firstName: 'Dirk',
            lastName: 'Domroese',
            image: 'https://ctsassets1.check24.de/size=100c100/di=3/nfc=200/source=aHR0cHM6Ly9kb2NzLnJlaXNlbi5jaGVjazI0LmRlLzc3MDA1NDQxLzJjNmJmMmIzZDgzZDdkYjdkZTJmZDkwYjYwYTJmMWM4NzI4NzEzNjY=!83254b/picture.jpg?cts_do=DESKTOP&cts_p=PR',
            quote: 'Sie suchen Ihr Traumhotel auf den Balearen? Wo Sie tolle Unterkünfte finden, kann ich Ihnen verraten.',
            phone: '089 7080 80 1040',
            jobTitle: 'Reiseberater',
            idHash: 'mvljav4fc35go0maqhx0ilyuf29u0vuhkvy1x4deui0la2',
            phoneLink: '+49897080801040',
            label: 'Reiseberater Balearen',
            special: 'CHECK24 Reiseexperte',
            education: 'als Kundenberater',
            experience: '6 Jahre Berufserfahrung',
            region: 'Mallorca',
            promo: '',
            phoneNumber: '',
            gender: '',
            serviceCode: '',
        },
        {
            rating: 5,
            firstName: 'Daniel',
            lastName: 'Mueller',
            image: 'https://ctsassets1.check24.de/size=100c100/di=3/nfc=200/source=aHR0cHM6Ly9kb2NzLnJlaXNlbi5jaGVjazI0LmRlLzUwNzI5NTkvMzY0ZDNiZGRkNDM0MmI1OGJlN2Q1ZmQ2NDVjYzlhYjFiNTlkZmE0NQ==!40fb43/picture.jpg?cts_do=DESKTOP&cts_p=PR',
            quote: 'Urlaub wie ein VIP? Auf den Balearen gibt es fantastische Luxushotels zum kleinen Preis. Ich unterstütze Sie gern bei Ihrer Suche.',
            phone: '089 7080 80 1008',
            jobTitle: 'Reiseberater',
            idHash: 'qng909dv85evxmqene8tnkgtk293g9u5027nk7acj535nm',
            phoneLink: '+49897080801008',
            label: 'Reiseberater Balearen',
            special: 'CHECK24 Reiseexperte',
            education: 'als Kundenberater',
            experience: '7 Jahre Berufserfahrung',
            region: 'Mallorca',
            promo: '',
            phoneNumber: '',
            gender: '',
            serviceCode: '',
        },
        {
            rating: 5,
            firstName: 'Daniel',
            lastName: 'Telker',
            image: 'https://ctsassets1.check24.de/size=100c100/di=3/nfc=200/source=aHR0cHM6Ly9kb2NzLnJlaXNlbi5jaGVjazI0LmRlLzI0OTY5MjA3L2VkZTQyMDRlNDg2YjQzYTZhMjlmOWQ2YTU0MThmMWZjOTBkMzYyZjI=!8b0886/picture.jpg?cts_do=DESKTOP&cts_p=PR',
            quote: 'Sie suchen die richtige Mischung aus Shopping, Strand und Sightseeing? Gerne helfe ich Ihnen mit einer Empfehlung auf den Balearen weiter.',
            phone: '089 7080 80 1091',
            jobTitle: 'Reiseberater',
            idHash: '19m3jjr5e0vbu0wx039m905dxtctxk2c89lwehmpiufdic',
            phoneLink: '+49897080801091',
            label: 'Reiseberater Balearen',
            special: 'CHECK24 Reiseexperte',
            education: 'als Kundenberater',
            experience: '6 Jahre Berufserfahrung',
            region: 'Mallorca',
            promo: '',
            phoneNumber: '',
            gender: '',
            serviceCode: '',
        },
        {
            rating: 5,
            firstName: 'Katrin',
            lastName: 'Dinkel',
            image: 'https://ctsassets1.check24.de/size=100c100/di=3/nfc=200/source=aHR0cHM6Ly9kb2NzLnJlaXNlbi5jaGVjazI0LmRlLzM2MTExMjAyLzA0ODk3ZjczZDk4YzE0YTAwMWJhNTIwNjIwNGU5NmVhNDYxNzEzYTY=!0adf3f/picture.jpg?cts_do=DESKTOP&cts_p=PR',
            quote: 'Sie suchen Ihr Traumhotel auf den Balearen? Wo Sie tolle Unterkünfte finden, kann ich Ihnen verraten.',
            phone: '089 7080 80 1071',
            jobTitle: 'Reiseberaterin',
            idHash: 'r5s4pfs5tg3gl7inmwjjhdl7uu7xqm1gobt9p3pg7l3fo7',
            phoneLink: '+49897080801071',
            label: 'Reiseberaterin Balearen',
            special: 'CHECK24 Reiseexpertin',
            education: 'als Kundenberaterin',
            experience: '6 Jahre Berufserfahrung',
            region: 'Mallorca',
            promo: '',
            phoneNumber: '',
            gender: '',
            serviceCode: '',
        },
    ],
};
